export interface SearchState {
  error?: Error;
  showSuggestions: boolean;
  query: string;
  refinement: string;
  searchDescription: {
    flavourTitle: string;
    flavourText: string;
  };
}

export const initialSearchState: SearchState = {
  query: "",
  refinement: "",
  showSuggestions: false,
  searchDescription: {
    flavourTitle: "",
    flavourText: "",
  },
};
